import { IFileView } from 'types/IFileView';
import myImage from 'assets/images/home/sherif.jpg';
import myCv from 'assets/files/sherif-cv.pdf';

export const NAME = 'Sherif Mohammad';
export const TITLE = 'Frontend Engineer';
export const IMAGE = myImage;
export const CV: IFileView = {
  title: 'View CV',
  link: myCv,
};
